<h2 mat-dialog-title class="dialog-title">
  <mat-icon>history</mat-icon>
  <span>Card History</span>
  <button mat-icon-button (click)="load()">
    <mat-icon>refresh</mat-icon>
  </button>

  <span class="spacer"></span>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  @if (loading) {
  <div class="loading-container">
    <mat-spinner diameter="36"></mat-spinner>
    <p>Loading card history...</p>
  </div>
  } @else if (history) {
  <section class="listing-section">
    <h3>Listed by</h3>
    <div class="listing-card">
      <div class="listing-row">
        <span class="listing-label">Player</span>
        <span>
          {{ history.listing.player_name }}
          @if (history.listing.player_nickname && history.listing.player_nickname !== history.listing.player_name) {
          ({{ history.listing.player_nickname }})
          }
        </span>
      </div>
      <div class="listing-row">
        <span class="listing-label">Sell Contract</span>
        <span>
          {{ history.listing.sell_contract_name || history.listing.sell_contract_id }}
          <span class="muted">&middot; {{ history.listing.sell_contract_status }}</span>
        </span>
      </div>
      <div class="listing-row">
        <span class="listing-label">Buy Now / Bid</span>
        <span>{{ history.listing.buy_now_price | number }} / {{ history.listing.bid_price | number }}</span>
      </div>
      <div class="listing-row">
        <span class="listing-label">Card Status</span>
        <span>{{ history.listing.card_status }}</span>
      </div>
      <div class="listing-row">
        <span class="listing-label">Listed At</span>
        <span>{{ formatDate(history.listing.sell_contract_started_at) }}</span>
      </div>
    </div>
  </section>

  <section class="allocations-section">
    <h3>Buy Contract History</h3>
    @if (history.allocations.length === 0) {
    <div class="empty-state">This card has never been allocated to a buy contract.</div>
    } @else {
    <div class="allocation-timeline">
      @for (entry of history.allocations; track trackByAllocationId($index, entry)) {
      <div class="allocation-entry">
        <div class="allocation-entry-top">
          <span class="buy-contract-name">{{ entry.buy_contract_name || entry.buy_contract_id }}</span>
          <span [class]="'status-badge ' + getAllocationStatusClass(entry.status)">{{ entry.status }}</span>
        </div>
        <div class="allocation-entry-meta">
          <div>
            <span class="meta-label">Buy Contract Status</span>
            {{ entry.buy_contract_status }}
          </div>
          <div>
            <span class="meta-label">Locked At</span>
            {{ formatDate(entry.locked_at) }}
          </div>
          <div>
            <span class="meta-label">Lock Expires</span>
            {{ formatDate(entry.lock_expires_at) }}
          </div>
          @if (entry.bought_at) {
          <div>
            <span class="meta-label">Bought At</span>
            {{ formatDate(entry.bought_at) }}
          </div>
          }
        </div>
      </div>
      }
    </div>
    }
  </section>
  } @else {
  <div class="empty-state">Card not found.</div>
  }
</mat-dialog-content>
